import { cn } from "@cronika/ui";
import { BetType } from "@cronika/proto/common/trading_pb";
import { FC } from "react";

const BuyArrow: FC<{ className?: string }> = ({ className }) => (
  <svg className={className} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.043 11.064C14.2087 11.064 14.3677 10.9982 14.4848 10.881C14.602 10.7638 14.6679 10.6049 14.6679 10.4391L14.6679 6.01971C14.6679 5.85398 14.602 5.69505 14.4848 5.57786C14.3677 5.46067 14.2087 5.39483 14.043 5.3948L9.62358 5.3948C9.45972 5.39765 9.30354 5.46474 9.18867 5.58162C9.07381 5.69851 9.00944 5.85583 9.00944 6.01971C9.00944 6.18359 9.07381 6.34091 9.18867 6.45779C9.30354 6.57468 9.45972 6.64177 9.62358 6.64461L12.5342 6.64461L5.6461 13.5327C5.52889 13.6499 5.46304 13.8089 5.46304 13.9747C5.46304 14.1404 5.52889 14.2994 5.6461 14.4166C5.76331 14.5338 5.92228 14.5997 6.08804 14.5997C6.2538 14.5997 6.41278 14.5338 6.52999 14.4166L13.4181 7.5285L13.4181 10.4391C13.4181 10.6049 13.484 10.7638 13.6011 10.881C13.7183 10.9982 13.8773 11.064 14.043 11.064Z"
      fill="currentColor"
    />
  </svg>
);

const SellArrow: FC<{ className?: string }> = ({ className }) => (
  <svg className={className} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.00408 13.9749C9.00411 14.1406 9.06996 14.2995 9.18714 14.4167C9.30433 14.5339 9.46326 14.5998 9.62899 14.5998L14.0484 14.5998C14.2141 14.5998 14.3731 14.5339 14.4903 14.4167C14.6074 14.2995 14.6733 14.1406 14.6733 13.9749L14.6733 9.55546C14.6705 9.39161 14.6034 9.23543 14.4865 9.12056C14.3696 9.00569 14.2123 8.94132 14.0484 8.94132C13.8845 8.94132 13.7272 9.00569 13.6103 9.12056C13.4934 9.23543 13.4263 9.39161 13.4235 9.55546L13.4235 12.4661L6.5354 5.57799C6.41819 5.46078 6.25922 5.39493 6.09346 5.39493C5.9277 5.39493 5.76872 5.46078 5.65151 5.57799C5.5343 5.6952 5.46846 5.85417 5.46846 6.01993C5.46846 6.18569 5.5343 6.34466 5.65151 6.46187L12.5396 13.35L9.62899 13.35C9.46326 13.35 9.30433 13.4158 9.18714 13.533C9.06996 13.6502 9.00408 13.8092 9.00408 13.9749Z"
      fill="currentColor"
    />
  </svg>
);

export const DirectionBadge: FC<{ betType: BetType; className?: string }> = ({ betType, className }) =>
  betType === BetType.CALL ? (
    <span
      className={cn(
        "inline-flex h-3 w-3 shrink-0 items-center justify-center rounded-full bg-success/15 text-success",
        className,
      )}
    >
      <BuyArrow className="h-3.5 w-3.5" />
    </span>
  ) : (
    <span
      className={cn(
        "inline-flex h-3 w-3 shrink-0 items-center justify-center rounded-full bg-danger/15 text-danger",
        className,
      )}
    >
      <SellArrow className="h-3.5 w-3.5" />
    </span>
  );
